module.exports = __webpack_public_path__ + "img/twitter.36547885.svg";